module.exports = __webpack_public_path__ + "static/media/om_faceshape_long.6cf30b24.png";